import axiosClient from "../axiosInstance";

export const getGOGroups = async (): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/guarantee-of-origins/client-groups`);

  return response.data;
};

export const createGOGroup = async (postData: any): Promise<any> => {
  const client = axiosClient();

  const response = await client.post(
    `/guarantee-of-origins/client-groups`,
    postData,
  );

  return response.data;
};

export const updateGOGroup = async (postData: any): Promise<any> => {
  const client = axiosClient();

  const response = await client.put(
    `/guarantee-of-origins/client-groups`,
    postData,
  );

  return response.data;
};

export const deleteGOGroup = async (postData: any): Promise<any> => {
  const client = axiosClient();

  const response = await client.delete(
    `/guarantee-of-origins/client-groups/delete`,
    { data: postData },
  );

  return response.data;
};

export const getGOYearlySummary = async (): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/guarantee-of-origins/summary/yearly`);

  return response.data;
};

export interface GOSummaryFilters {
  productionSupport?: boolean;
  investmentSupport?: boolean;
  filterByGroups?: boolean;
  country?: string;
  technology?: string;
}

export const getGOSummary = async (
  filters?: GOSummaryFilters,
): Promise<any> => {
  const client = axiosClient();

  const params = new URLSearchParams();

  if (filters?.productionSupport !== undefined) {
    params.append("productionSupport", String(filters.productionSupport));
  }
  if (filters?.investmentSupport !== undefined) {
    params.append("investmentSupport", String(filters.investmentSupport));
  }
  if (filters?.filterByGroups !== undefined) {
    params.append("filterByGroups", String(filters.filterByGroups));
  }
  if (filters?.country) {
    params.append("country", filters.country);
  }
  if (filters?.technology) {
    params.append("technology", filters.technology);
  }

  const queryString = params.toString();
  const url = `/guarantee-of-origins/summary${queryString ? `?${queryString}` : ""}`;

  const response = await client.get(url);

  return response.data;
};

export const exportGOCertificates = async (filters?: {
  [key: string]: string | string[];
}): Promise<any> => {
  const client = axiosClient();

  const params = new URLSearchParams();

  // Add all filters to query params; arrays are appended as repeated keys.
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => params.append(key, v));
      } else if (value !== undefined && value !== null && value !== "") {
        params.append(key, String(value));
      }
    });
  }

  const queryString = params.toString();
  const url = `/guarantee-of-origins/export${queryString ? `?${queryString}` : ""}`;

  const response = await client.get(url, {
    responseType: "blob",
  });

  return response.data;
};

export const exportGOSummary = async (
  filters?: GOSummaryFilters,
): Promise<any> => {
  const client = axiosClient();

  const params = new URLSearchParams();

  if (filters?.productionSupport !== undefined) {
    params.append("productionSupport", String(filters.productionSupport));
  }
  if (filters?.investmentSupport !== undefined) {
    params.append("investmentSupport", String(filters.investmentSupport));
  }
  if (filters?.filterByGroups !== undefined) {
    params.append("filterByGroups", String(filters.filterByGroups));
  }
  if (filters?.country) {
    params.append("country", filters.country);
  }
  if (filters?.technology) {
    params.append("technology", filters.technology);
  }

  const queryString = params.toString();
  const url = `/guarantee-of-origins/summary/export${queryString ? `?${queryString}` : ""}`;

  const response = await client.get(url, {
    responseType: "blob",
  });

  return response.data;
};

export const syncGOs = async (): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/guarantee-of-origins/sync`);

  return response.data;
};

export const getLastGoSyncTime = async (): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/guarantee-of-origins/last-sync-time`);

  return response.data;
};

export const getUnsyncedGOClients = async (): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(
    `/guarantee-of-origins/unsynced-clients`,
  );

  return response.data;
};

export const getGOActiveClients = async (): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(
    `/guarantee-of-origin-settings/active-clients`,
  );

  return response.data;
};

export interface TransferGOCertificatesRequest {
  clientId: number;
  registryId: number;
  certs: Array<{
    certId: number;
    amount: number;
  }>;
}

export const transferGOCertificates = async (
  data: TransferGOCertificatesRequest,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.post(`/guarantee-of-origins/transfer`, data);

  return response.data;
};
